import React from "react";

// Define the type for the component's props if you wanted to make the URL dynamic
interface MetabaseDashboardEmbedProps {
  // If you want to allow different URLs, define them here:
  // srcUrl: string;
  // title: string;
}

const AccessAnalytics: React.FC<MetabaseDashboardEmbedProps> = () => {
  const embedUrl =
    "https://intact-angler.metabaseapp.com/public/dashboard/07e47ab2-a345-4391-8743-e3c5998ec3fe";

  return (
    <iframe
      src={embedUrl}
      title="access analytics"
      frameBorder="0"
      style={{ width: "100%", height: "100vh", border: "none" }}
    ></iframe>
  );
};

export default AccessAnalytics;
